/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable require-jsdoc */
import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {AiFillDownCircle, AiFillUpCircle} from 'react-icons/ai';

export default function Accordion({
  title,
  content,
  buttonColor,
  headingTextSize,
  //   textSize,
  iconSize,
  //   lineHeight,
  //   contentTopMargin,
}) {
  const [isActive, setIsActive] = useState(false);

  return (
    <>
      <div
        style={{display: 'flex', flexDirection: 'column', padding: '20px'}}
        onClick={() => setIsActive(!isActive)}
      >
        <div
          style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}
        >
          <span>
            <h1 style={{fontSize: headingTextSize}}>{title}&nbsp;&nbsp;</h1>
          </span>
          {isActive ? (
            <AiFillUpCircle
              style={iconSize}
              size={iconSize}
              color={buttonColor}
            />
          ) : (
            <AiFillDownCircle size={iconSize} color={buttonColor} />
          )}
        </div>
        <br />

        <br />
      </div>
      {isActive && <>{content}</>}
    </>
  );
}

Accordion.propTypes = {
  title: PropTypes.string,
  content: PropTypes.element,
  buttonColor: PropTypes.string,
  headingTextSize: PropTypes.string,
  textSize: PropTypes.string,
  iconSize: PropTypes.number,
  lineHeight: PropTypes.string,
  contentTopMargin: PropTypes.number,
};
